/* Timssan — Tailles dispo synchronisées au swatch couleur (cards collection) */
(function () {
  'use strict';

  var COLOR_KEYS = ['couleur', 'couleurs', 'color', 'colors', 'colour', 'colours'];

  function findColorLabel(node) {
    if (!node || !node.closest) return null;
    var label = node.closest('label.swatch');
    if (!label) return null;
    var name = (label.getAttribute('data-option-name') || '').toLowerCase().trim();
    if (COLOR_KEYS.indexOf(name) === -1) return null;
    return label;
  }

  function findCard(node) {
    return node.closest('product-card') || node.closest('.product-card--root');
  }

  function colorFromLabel(label) {
    var c = label.getAttribute('aria-label');
    if (c) return c.trim();
    var input = label.querySelector('input[type="radio"]');
    return input ? (input.value || '').trim() : '';
  }

  function updateCard(card, color) {
    if (!card || !color) return;
    var overlay = card.querySelector('[data-up-card-sizes][data-sizes-map]');
    if (!overlay) return;
    var raw = overlay.getAttribute('data-sizes-map');
    if (!raw) return;
    var map;
    try { map = JSON.parse(raw); } catch (e) { return; }
    var avail = map[color] || [];
    var items = overlay.querySelectorAll('.up-card-sizes__item');
    for (var i = 0; i < items.length; i++) {
      var size = (items[i].textContent || '').trim();
      items[i].setAttribute('data-available', avail.indexOf(size) !== -1 ? 'true' : 'false');
    }
    overlay.setAttribute('data-current-color', color);
  }

  function handle(e) {
    var label = findColorLabel(e.target);
    if (!label) return;
    var card = findCard(label);
    if (!card) return;
    var color = colorFromLabel(label);
    if (!color) return;
    updateCard(card, color);
  }

  document.addEventListener('click', handle, true);
  document.addEventListener('change', handle, true);
})();
